import { IconButton } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useLocalStorageValue } from '@react-hookz/web';
import { PATHS } from 'constants/paths';
import { ObjectKeys } from 'helpers/ts-helpers';
import { useIsDev } from 'hooks/useIsDev';
import { ONBOARDING } from 'services/localStorer';

import styles from './OnboardingToggle.module.scss';

const pagesWithOnboarding: (keyof typeof PATHS)[] = ObjectKeys(ONBOARDING);
const doesCurrentPageHasOnboarding = (
  currentPage: keyof typeof PATHS,
  isDev: boolean,
): currentPage is keyof typeof ONBOARDING => isDev && pagesWithOnboarding.includes(currentPage);

const OnboardingToggle = ({
  currentPage,
}: {
  currentPage: keyof typeof ONBOARDING;
}): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setShouldDisplayOnboarding] = useLocalStorageValue(ONBOARDING[currentPage]);

  return (
    <IconButton
      data-testid="onboarding-toggle"
      className={styles.onboardingButton}
      onClick={() => setShouldDisplayOnboarding(true)}
    >
      <HelpOutlineIcon />
    </IconButton>
  );
};

const OnboardingToggleHOC = ({ currentPage }: { currentPage: keyof typeof PATHS }): JSX.Element => {
  const isDev = useIsDev();

  if (!doesCurrentPageHasOnboarding(currentPage, isDev)) {
    return <></>;
  }

  return <OnboardingToggle currentPage={currentPage} />;
};

export default OnboardingToggleHOC;
